import { CloudBackground } from './CloudBackground.tsx';
import { GoogleSignIn } from './GoogleSignIn.tsx';
import { PublicTopBar } from './GamesTopBar.tsx';

export function SignInLanding({ onCredential }: { onCredential: (credential: string) => Promise<void> }) {
  return (
    <div className="auth-page">
      <CloudBackground />
      <PublicTopBar />
      <main className="auth-main rail">
        <section className="auth-copy">
          <p className="eyebrow">My Genius Games</p>
          <h1>Play. Compete. Climb.</h1>
          <p>Your scores follow you, your best runs count, and the leaderboard is waiting.</p>
          <GoogleSignIn onCredential={onCredential} />
          <p className="signin-note">Use the same Google account you use on My Genius.</p>
        </section>
      </main>
    </div>
  );
}
